import {ColorInput as MantineColorInput, ColorInputProps} from '@mantine/core';
import {FC} from 'react';
import {AdapterProps, FieldAdapter} from '../field-factory';

export type $ColorInputAdapterProps = AdapterProps<ColorInputProps>;

export const $ColorInputAdapter: FC<FieldAdapter<$ColorInputAdapterProps>> = ({
  inputProps: {onChange, ...inputProps},
  control,
}) => {
  const {
    field: {value, onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid}
  } = control;

  const _onChange: ColorInputProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineColorInput
      error={invalid}
      onChange={_onChange}
      value={value}
      checked={value}
      {...fieldProps}
      {...inputProps}
    />
  );
};